var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useSWR from "swr";
import { apiFetch, LoadingIcon, StyledButton, StyledButtonStyle, } from "ee-react-components";
import { process } from "../../Process";
/**
 * The incident's change log, newest first.
 *
 * Fetched here rather than passed in: the log is only wanted when someone asks
 * for it, and it grows with every edit while the incident itself does not.
 */
export var IncidentAuditLogDialog = function (_a) {
    var uid = _a.uid, title = _a.title, onClose = _a.onClose;
    var _b = useAuth0(), getAccessTokenSilently = _b.getAccessTokenSilently, isLoading = _b.isLoading, isAuthenticated = _b.isAuthenticated;
    var getToken = useCallback(function () {
        return getAccessTokenSilently({
            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
        });
    }, [getAccessTokenSilently]);
    var _c = useSWR(isLoading || !isAuthenticated
        ? null
        : "".concat(process.env.NOC_SVC_URL, "/incidents/").concat(uid, "/audit-log"), function (url) {
        return apiFetch(url, {
            method: "GET",
            callbacks: { getToken: getToken },
        });
    }), entries = _c.data, error = _c.error;
    // Newest first: the change log is served oldest-first so it replays in order,
    // but someone opening it wants the most recent edit at the top.
    var newestFirst = entries ? __spreadArray([], entries, true).reverse() : undefined;
    return (React.createElement("div", { className: "bg-black-1150 rounded-[20px] p-[32px] flex flex-col gap-y-[32px] min-w-[650px] max-w-[900px] max-h-[85vh] overflow-y-auto" },
        React.createElement("label", { className: "font-N6 text-white w-full text-left" }, title),
        newestFirst == null && error == null && (React.createElement("div", { className: "w-[32px] h-[32px]" }, LoadingIcon)),
        error != null && (React.createElement("label", { className: "font-N7 text-red" }, "Could not load the audit log: ".concat(error.message))),
        (newestFirst === null || newestFirst === void 0 ? void 0 : newestFirst.length) === 0 && (React.createElement("label", { className: "font-N7 text-black-400" }, "No changes recorded.")),
        React.createElement("div", { className: "flex flex-col gap-y-4" }, newestFirst === null || newestFirst === void 0 ? void 0 : newestFirst.map(function (entry) { return (React.createElement("div", { className: "flex flex-col gap-y-2 border-l-2 border-black-800 pl-4", key: entry.id },
            React.createElement("div", { className: "flex flex-row gap-x-4 items-center flex-wrap" },
                React.createElement("label", { className: "font-N8 text-black-400" }, "".concat(entry.username, " \u2014 ").concat(new Date(entry.at).toLocaleString()))),
            React.createElement("label", { className: "font-N8p5 text-white" }, entry.summary))); })),
        React.createElement("div", { className: "flex flex-row gap-x-4" },
            React.createElement(StyledButton, { text: "CLOSE", style: StyledButtonStyle.Gray, onClick: onClose }))));
};
